export const LogoMark = ({ size = 34 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect width="32" height="32" rx="6" fill="#F7F6F2" />
    <path d="M9 22V10L16 16L9 22Z" fill="#25282D" />
    <circle cx="21.5" cy="16" r="4" fill="#B89A63" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-3" data-testid="logo">
    <LogoMark />
    <span className="flex items-baseline gap-2">
      <span className="font-serif text-[22px] leading-none font-semibold tracking-tight text-charcoal">
        SSDE
      </span>
      <span className="font-mono text-[10px] uppercase tracking-[0.32em] text-gold-deep">
        LTD
      </span>
    </span>
  </span>
);
